<template>
  <div class="body-info-pay-card">
    <div class="cell-box">

      <div class="wx-text-reply" v-if="copyPayText">
        <div class="content-container">
          <div class="text-content">{{copyPayText}}</div>
          <div class="mp-url" v-if="mpFollowUrl">
            <img :src="mpFollowUrl" class="mp-qr-code">
          </div>
        </div>
        <div class="copy-box" v-clipboard:copy="copyPayText" v-clipboard:success="onCopySuccess" >
           <Button plain class="btn-copy" >点击复制</Button>
        </div>
      </div>
      <div class="wx-pay-info" v-else-if="qrUrl">
        <div class="wx-pay-tip">请用微信扫描二维码完成支付</div>
        <img :src="qrUrl" class="qr-code"/>
        <div class="wx-sub-tip">先截屏
          <icon-svg icon-class="arrow-right"></icon-svg>
          打开微信扫一扫
          <icon-svg icon-class="arrow-right"></icon-svg>
          选择相册二维码
        </div>
      </div>
      <div v-else>
        <div class="box-desc">套餐选择</div>
        <div class="recharge-order-items-container">
          <div :class="['order-item', orderItem.id === selectedMoneyOrder.id? 'selected-item-box':'']"
               v-for="orderItem in orderItemList" :key="orderItem.id" @click="onSelectOrder(orderItem)">
            <div class="item-box">
              <img src="http://a1.wanwanshequ.com/static/public/5424789a439c2ef5.png" class="img-first-recharge"
                   v-if="orderItem.is_first">
              <icon-svg icon-class="hot" class="icon-hot" v-else-if="orderItem.is_hot"></icon-svg>
              <img src="http://a1.wanwanshequ.com/static/public/761699366fdeb250.png" class="img-vip-recharge"
                   v-else-if="orderItem.is_vip">
              <div class="item-detail">
                <div class="title">{{orderItem.title}}</div>
                <div class="description">{{orderItem.description}}</div>
                <div class="sub-description">{{orderItem.sub_description}}</div>
              </div>
            </div>
          </div>
        </div>


        <div v-if="orderItemListVip && orderItemListVip.length > 0" class="vip-container">
          <div class="box-desc">小说&漫画 VIP (仅对全站小说和漫画内容有效)</div>
          <div class="recharge-order-items-container">
            <div :class="['order-item', orderItem.id === selectedMoneyOrder.id? 'selected-item-box':'']"
                 v-for="orderItem in orderItemListVip" :key="orderItem.id" @click="onSelectOrder(orderItem)">
              <div class="item-box">
                <img src="http://a1.wanwanshequ.com/static/public/761699366fdeb250.png" class="img-vip-recharge"
                     v-if="orderItem.is_vip">
                <div class="item-detail">
                  <div class="title">{{orderItem.title}}</div>
                  <div class="description">{{orderItem.description}}</div>
                  <div class="sub-description">{{orderItem.sub_description}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cell-box">
      <RadioGroup v-model="selectedPayMethod" class="radio-container">
        <Radio
            v-for="(option, index) in payMethodOptions"
            :key="index"
            :name="option.name"
            checked-color="#fc9153"
            class="radio-item"
        >
          <img :src="option.image_url" class="pay-logo-img"/>
        </Radio>
      </RadioGroup>
    </div>

    <div class="cell-box info-gap">
      <div class="box-desc">
        当前用户
      </div>
      <div class="user-stats">
        <div class="user-name-container">用户名: <span class="user-name">{{userAccountName}}</span></div>
        <div class="user-credit-container">币余额: <span class="user-credit">{{userCredit}}币</span></div>
      </div>
    </div>

    <div class="confirm-pay-box" v-if="!loading">
      <div class="price-desc" v-if="selectedMoneyOrder.price">¥<span
          style="font-size: 18px; color: red; font-weight: bold; margin-left: 5px;">{{selectedMoneyOrder.price}}</span>
      </div>
      <Button type="warning" :loading="creditLoading" class="confirm-pay-btn" round
              @click="onClickConfirmPay">确认支付
      </Button>
    </div>
  </div>
</template>

<script>
  import {makeCallbackUrl} from "../../util/parse_params";
  import {Toast, Radio, RadioGroup, Button} from "vant"

  export default {
    name: "PayCard",
    components: {Toast, RadioGroup, Radio, Button},
    props: {
      refer: {},
      callback: {},
      scene: {
        type: String,
        value: "",
      }
    },
    data() {
      return {
        qrUrl: "",
        callbackUrl: "",
        userInfo: {},

        orderId: 0,
        orderType: "",
        orderStatus: "",

        loading: true,
        creditLoading: false,
        orderItemListVip: [],
        orderItemList: [],
        config: {},

        selectedMoneyOrder: {},
        selectedPayMethod: "",
        payMethodOptions: [],

        copyPayText: "",
        mpFollowUrl : "",
      }
    },
    mounted() {
      this.loadOrderMenu()
      this.loadUserInfo()
    },
    methods: {
      async loadOrderMenu() {
        this.loading = true
        let params = {
          "scene": this.scene || ""
        }
        await this.$store.dispatch("GetCreditMenu", params).then((data) => {
          if (data.code === 0) {
            this.orderItemList = data.data.menu_list
            this.splitOrderList()
            this.config = data.data.config
            this.payMethodOptions = this.config.pay_method_list
            this.selectedPayMethod = this.config.default_pay_method_name

            for (let i = 0; i < data.data.menu_list.length; i++) {
              if (data.data.menu_list[i].id === data.data.config.default_menu_item_id) {
                this.selectedMoneyOrder = data.data.menu_list[i]
                break
              }
            }
          }
        }, () => {
        })
        this.loading = false
      },

      splitOrderList() {
        let vipList = []
        let itemList = []
        if (this.scene === "recharge") {
          for (let i = 0; i < this.orderItemList.length; i ++) {
            if (this.orderItemList[i].is_vip) {
              vipList.push(this.orderItemList[i])
            } else {
              itemList.push(this.orderItemList[i])
            }
          }
          this.orderItemList = itemList
          this.orderItemListVip = vipList
        }
      },

      async onClickConfirmPay() {
        this.creditLoading = true

        await this.doCreateOrder()
        this.callbackUrl = makeCallbackUrl(this.callback, window.location.href, this.refer)

        if (this.orderStatus === "finished") { // 0 元购， 无需支付
          this.createToast("订单已完成", "correct")
          setTimeout(() => {
            window.location.replace(this.callbackUrl)
          }, 500)
        } else {
          if (this.checkIsWxPay()) {
            this.onClickWxPay()
          } else {
            this.onClickAlipay()
          }
        }
      },

      checkIsWxPay() {
        for (let i = 0; i < this.payMethodOptions.length; i++) {
          if (this.payMethodOptions[i].name === this.selectedPayMethod) {
            if (this.payMethodOptions[i].is_wx) {
              return true
            } else {
              return false
            }
          }
        }
      },

      onSelectOrder(item) {
        this.selectedMoneyOrder = item
      },

      createToast(text, type) {
        Toast(text)
      },

      async doCreateOrder() {
        let reqParams = {
          "price": this.selectedMoneyOrder.price,
          "credit_count": this.selectedMoneyOrder.credit,
          "deal_id": this.selectedMoneyOrder.id,
        }

        if (this.refer) {
          reqParams.refer = '' + this.refer
        }

        await this.$store.dispatch("CreateOrderCredit", reqParams).then((data) => {
          if (data.code === 0) {
            this.orderId = data.data.order_id
            this.orderType = data.data.order_type
            this.orderStatus = data.data.order_status

          } else if (data.code === 20010) {
            this.createToast("尚未登录", "error")
            this.creditLoading = false
          } else {
            this.createToast("系统错误", "error")
            this.creditLoading = false
          }
        }, (err) => {
          this.createToast("网络异常", "error")
          this.creditLoading = false
        })
      },

      async onClickAlipay() {
        let payParams = {
          pay_method: this.selectedPayMethod,
          order_id: this.orderId,
          order_type: this.orderType,
          callback_url: this.callbackUrl,
        }
        this.creditLoading = true
        await this.$store.dispatch("PayOrder", payParams).then(
            (data) => {
              if (data.code === 0) {
                let toUrl = data.data.redirect_to
                window.location.replace(toUrl)
              }
            }, () => {
              this.createToast("网络异常", "error")
            }
        )
        this.creditLoading = false
      },

      async onClickWxPay() {
        let payParams = {
          "pay_method": this.selectedPayMethod,
          "order_id": this.orderId,
          "order_type": this.orderType,
          "callback_url": this.callbackUrl,
        }
        this.creditLoading = true
        await this.$store.dispatch("PayOrder", payParams).then((data) => {
          if (data.code === 0) {
            let qrUrl = data.data.qr_url || ""
            let copyPayText = data.data.text || ""
            let mpUrl = data.data.mp_img_url || ""
            if (!qrUrl && !copyPayText) {
              this.createToast("系统错误", "error")
            } else {
              this.qrUrl = qrUrl
              this.copyPayText = copyPayText
              this.mpFollowUrl = mpUrl
            }
          } else {
            this.createToast("系统错误", "error")
          }
        }, () => {
          this.createToast("网路异常", "error")
        })
        this.creditLoading = false
      },

      loadUserInfo() {
        this.$store.dispatch("AccountInfoMine").then((data) => {
          if (data.code === 0) {
            this.userInfo = data.data
          }
        }, () => {

        })
      },

      onCopySuccess() {
        this.createToast("复制成功", "success")
      }
    },
    computed: {
      userAccountName() {
        if (this.userInfo && this.userInfo.id) {
          if (this.userInfo.nickname) {
            return this.userInfo.nickname
          } else {
            return this.userInfo.account_name
          }
        } else {
          return ""
        }
      },

      userCredit() {
        if (this.userInfo && this.userInfo.id) {
          return this.userInfo.credit
        }
        return 0
      }
    },

    watch: {
      selectedPayMethod(newVal, oldVal) {
        this.qrUrl = ""
        this.copyPayText = ""
      }
    }
  }
</script>

<style scoped lang="scss">

  .body-info-pay-card {
    background: #f2f2f2;
  }

  .vip-container {
    margin-top: 12px;
  }


  .recharge-order-items-container {
    padding: 0 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .order-item {
      flex: 0 1 auto;
      width: 47%;
      border: 1px solid rgba(203, 203, 203, 0.58);
      margin: 4px 0;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;

      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      position: relative;

      .icon-hot {
        position: absolute;
        font-size: 28px;
        top: 0;
        right: 0;
      }

      .img-first-recharge {
        position: absolute;
        font-size: 28px;
        top: -10px;
        right: 0;
        width: 45px;
      }

      .img-vip-recharge {
        position: absolute;
        font-size: 28px;
        top: 5px;
        right: 0;
        width: 30px;
      }

      .item-detail {
        padding: 8px 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
      }

      .title {
        font-size: 18px;
        font-weight: bold;
      }

      .description {
        margin-top: 5px;
        font-size: 14px;
        color: #333;
      }

      .sub-description {
        font-size: 12px;
        margin-top: 5px;
        color: rgba(255, 103, 91, 0.95);
        text-align: center;
      }

      .item-price {
        font-size: 16px;
        font-weight: bold;
      }

      .item-credit {

      }
    }

    .selected-item-box {
      border: 1px solid red;
    }
  }


  .cell-box {
    background: white;
    padding: 3px 4px;
    color: #2d2d2d;

    .box-desc {
      padding: 4px 5px;
    }

    .radio-container {
      padding: 12px 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .radio-item {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .pay-logo-img {
      height: 20px;
    }

    .user-stats {
      color: grey;
      display: flex;
      flex-wrap: wrap;
      padding: 10px 10px;
      justify-content: space-between;

      .user-name-container {
        padding: 5px 8px;

        .user-name {
          margin-left: 5px;
          color: rgba(0, 0, 0, 0.84);
        }
      }

      .user-credit-container {
        padding: 5px 8px;
        flex: 0 0 auto;
        min-width: 35%;

        .user-credit {
          margin-left: 5px;
          color: rgba(0, 0, 0, 0.84);
        }
      }
    }

    .tip-box {
      font-size: 12px;
      color: rgba(110, 110, 110, 0.75);
      padding: 5px 12px;
      line-height: 1.8;
    }
  }

  .info-gap {
    margin-top: 5px;
  }

  .confirm-pay-box {
    padding: 8px 12px;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #f2f2f2;

    .price-desc {
      padding: 0 12px;
      color: red;
    }

    .confirm-pay-btn {
      font-size: 16px;
      padding: 10px 0;
      width: 65%;
    }
  }

  .wx-pay-info {
    padding: 12px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .wx-pay-tip {
      font-size: 18px;
    }

    .wx-sub-tip {
      color: #5d5d5d;
      font-size: 13px;
    }

    .qr-code {
      margin: 5px 0;
      width: 100px;
      height: 100px;
    }
  }


  .wx-text-reply {
    padding: 12px 8px;

    .content-container {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .text-content {
      background-color: #fafafa;
      padding: 18px;
      font-size: 16px;
      flex: 1 1 auto;
      line-height: 1.5;
    }

    .mp-url {
      width: 140px;
    }
    .mp-qr-code {
      width:100%;
    }

  }
  .copy-box {
    padding: 8px 0;
    text-align: center;
  }

  .btn-copy {
    width: 100%;
  }

</style>
